import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import studies from './modules/studies';
import study from './modules/study';
import mySubmissions from './modules/my-submissions';
import ui from './modules/ui';
import createPersistedState from 'vuex-persistedstate';
import teacher from './modules/teacher';
import uploadSubmission from './modules/upload-submission';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    studies,
    study,
    mySubmissions,
    ui,
    uploadSubmission,
    teacher,
  },
  plugins: [
    createPersistedState({
      paths: ['auth', 'study', 'ui'],
    }),
  ],
});
